import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DateInterface } from '../../models/date-time.models';

@Component({
  selector: 'std-mini-calendar',
  template: ` <div
    [class]="
      'w-full flex flex-wrap content-between gap-y-4 select-none text-14 leading-14 ' +
      customClassContainer
    "
  >
    <div
      [class]="'w-full flex place-content-between ' + customClassMonthSelector"
    >
      <div class="cursor-pointer" (click)="prevMonth()"><</div>
      <div>
        {{
          translocoPipe
            ? monthList[getCurrentMonth()].traslated
            : monthList[getCurrentMonth()].unTraslated
        }}
        {{ getCurrentYear() }}
      </div>
      <div class="cursor-pointer" (click)="nextMonth()">></div>
    </div>
    <div
      [class]="'w-[14%] flex place-content-center font-bold ' + classDayOfWeek"
    >
      {{ translocoPipe ? translocoPipe('week.lun') : 'Lun' }}
    </div>
    <div
      [class]="'w-[14%] flex place-content-center font-bold ' + classDayOfWeek"
    >
      {{ translocoPipe ? translocoPipe('week.mar') : 'Mar' }}
    </div>
    <div
      [class]="'w-[14%] flex place-content-center font-bold ' + classDayOfWeek"
    >
      {{ translocoPipe ? translocoPipe('week.mer') : 'Mer' }}
    </div>
    <div
      [class]="'w-[14%] flex place-content-center font-bold ' + classDayOfWeek"
    >
      {{ translocoPipe ? translocoPipe('week.gio') : 'Gio' }}
    </div>
    <div
      [class]="'w-[14%] flex place-content-center font-bold ' + classDayOfWeek"
    >
      {{ translocoPipe ? translocoPipe('week.ven') : 'Ven' }}
    </div>
    <div
      [class]="'w-[14%] flex place-content-center font-bold ' + classDayOfWeek"
    >
      {{ translocoPipe ? translocoPipe('week.sab') : 'Sab' }}
    </div>
    <div
      [class]="'w-[14%] flex place-content-center font-bold ' + classDayOfWeek"
    >
      {{ translocoPipe ? translocoPipe('week.dom') : 'Dom' }}
    </div>
    @for (day of listOfDays; track $index){
    <div
      (click)="day.day > 0 ? dayClicked(day) : null"
      class="w-[14%] flex place-content-center {{ customClassDay }} {{
        day.day === selectedDay &&
        day.month === this.selectedDate.month &&
        day.year === this.selectedDate.year
          ? customClassDaySelected
          : ''
      }}"
      [ngClass]="{
        'cursor-pointer': day.day > 0,
        'pointer-events-none opacity-50': !day.isActive
      }"
    >
      {{ day.day > 0 ? day.day : '' }}
    </div>
    }
    <ng-content />
  </div>`,
  styles: [],
  standalone: false,
})
export class MiniCalendarComponent implements OnInit {
  constructor() {}

  @Input() translocoPipe: any;
  @Input() currentDate: Date = new Date();
  @Input() selectedDay: number = 0;
  @Input() minDate?: Date;
  @Input() classDayOfWeek: string = '';
  @Input() customClassContainer: string = '';
  @Input() customClassDay: string = '';
  @Input() customClassDaySelected: string = 'text-primary font-bold';
  @Input() customClassMonthSelector: string = '';
  @Input() selectedDate: DateInterface = {
    day: new Date().getDate(),
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
    isActive: true,
    dayOfTheWeek: new Date().getDay(),
    formattedDate: this.getFormattedDate(new Date()),
  };
  @Output() changeDate: EventEmitter<DateInterface> =
    new EventEmitter<DateInterface>();
  listOfDays: DateInterface[] = [];
  monthList = [
    {
      traslated: 'month.gen',
      unTraslated: 'Gennaio',
    },
    {
      traslated: 'month.feb',
      unTraslated: 'Febbraio',
    },
    {
      traslated: 'month.mar',
      unTraslated: 'Marzo',
    },
    {
      traslated: 'month.apr',
      unTraslated: 'Aprile',
    },
    {
      traslated: 'month.mag',
      unTraslated: 'Maggio',
    },
    {
      traslated: 'month.giu',
      unTraslated: 'Giugno',
    },
    {
      traslated: 'month.lug',
      unTraslated: 'Luglio',
    },
    {
      traslated: 'month.ago',
      unTraslated: 'Agosto',
    },
    {
      traslated: 'month.set',
      unTraslated: 'Settembre',
    },
    {
      traslated: 'month.ott',
      unTraslated: 'Ottobre',
    },
    {
      traslated: 'month.nov',
      unTraslated: 'Novembre',
    },
    {
      traslated: 'month.dic',
      unTraslated: 'Dicembre',
    },
  ];

  ngOnInit(): void {
    this.selectedDay = new Date(this.currentDate).getDate();
    this.selectedDate = {
      day: new Date(this.currentDate).getDate(),
      month: new Date(this.currentDate).getMonth(),
      year: new Date(this.currentDate).getFullYear(),
      isActive: true,
      dayOfTheWeek: new Date(this.currentDate).getDay(),
      formattedDate: this.getFormattedDate(new Date(this.currentDate)),
    };
    this.getListOfDays();
  }

  getFormattedDate(myDate: Date) {
    const date = new Date(myDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  getListOfDays() {
    let date = this.currentDate ? new Date(this.currentDate) : new Date();
    let currentYear = date.getFullYear();
    let currentMonth = date.getMonth();
    let currentMonthTotalDays = new Date(
      currentYear,
      currentMonth + 1,
      0
    ).getDate();
    let currentFirstDayOfMonth = new Date(currentYear, currentMonth, 1);
    let newListOfDays = [];
    for (
      let index =
        0 -
        ((currentFirstDayOfMonth.getDay() == 0
          ? 7
          : currentFirstDayOfMonth.getDay()) -
          1);
      index < currentMonthTotalDays;
      index++
    ) {
      newListOfDays.push({
        day: index + 1,
        month: currentMonth,
        year: currentYear,
        isActive: this.minDate
          ? new Date(currentYear, currentMonth, index + 1, 1) >=
            new Date(this.minDate)
          : true,
        dayOfTheWeek: new Date(currentYear, currentMonth, index + 1).getDay(),
        formattedDate: this.getFormattedDate(
          new Date(currentYear, currentMonth, index + 1)
        ),
      });
    }
    this.listOfDays = newListOfDays;
  }

  dayClicked(day: any) {
    this.selectedDay = day.day;

    this.selectedDate = day;

    this.changeDate.emit(day);
  }

  getCurrentYear() {
    return this.currentDate
      ? new Date(this.currentDate).getFullYear()
      : new Date().getFullYear();
  }

  prevMonth() {
    let date = this.currentDate ? new Date(this.currentDate) : new Date();
    let currentYear = date.getFullYear();
    let currentMonth = date.getMonth();
    let newCurrentDate = new Date(currentYear, currentMonth, 0);
    this.currentDate = newCurrentDate;
    this.getListOfDays();
  }

  nextMonth() {
    let date = this.currentDate ? new Date(this.currentDate) : new Date();
    let currentYear = date.getFullYear();
    let currentMonth = date.getMonth();
    let newCurrentDate = new Date(currentYear, currentMonth + 2, 0);
    this.currentDate = newCurrentDate;
    this.getListOfDays();
  }

  getCurrentMonth() {
    return this.currentDate
      ? new Date(this.currentDate).getMonth()
      : new Date().getMonth();
  }
}
